import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { isTagTypeTimer, isTagTypeText } from '../BannerV2/helpers';
const TimerText = (timeLeft, timerEndText) => {
    const { completed, days, hours, minutes, seconds, } = timeLeft;
    if (completed) {
        return (React.createElement("span", null, timerEndText));
    }
    if (days >= 1) {
        return (React.createElement("span", null,
            days,
            "d",
            ' ',
            hours,
            "h",
            ' ',
            minutes,
            "m",
            ' ',
            seconds,
            "s"));
    }
    return (React.createElement("span", null,
        hours,
        "h",
        ' ',
        minutes,
        "m",
        ' ',
        seconds,
        "s"));
};
const TagTextWrapper = styled.span `
  display: block;
`;
const Timer = (props) => {
    const { timeStamp, timerEndText, tagTimerEnd, tagText, tagType, } = props;
    const addPaddingToNumber = (num) => {
        let numString = num.toString();
        while (numString.length < 2)
            numString = `0${numString}`;
        return numString;
    };
    const calculateTimeLeft = (currentTime) => {
        const difference = (currentTime) - +(new Date());
        if (difference > 0) {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: addPaddingToNumber(Math.floor((difference / (1000 * 60 * 60)) % 24)),
                minutes: addPaddingToNumber(Math.floor((difference / 1000 / 60) % 60)),
                seconds: addPaddingToNumber(Math.floor((difference / 1000) % 60)),
                completed: false,
                difference,
            };
        }
        return {
            completed: true,
            difference: 0,
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
        };
    };
    const actualTimeLeft = calculateTimeLeft(Number(timeStamp));
    const [timeLeft, setTimeLeft] = useState(actualTimeLeft);
    const isTimer = isTagTypeTimer({ tagType });
    const isText = isTagTypeText({ tagType, tagText }, 'text');
    const isHTML = isTagTypeText({ tagType, tagText }, 'html');
    useEffect(() => {
        if (timeLeft.difference > 0) {
            setTimeout(() => {
                const currentTimeLeft = calculateTimeLeft(Number(timeStamp));
                setTimeLeft(currentTimeLeft);
            }, 1000);
        }
    }, [timeLeft.difference]);
    const isTagTextVisible = !!(isTimer && timeLeft.completed && (timerEndText === ''));
    return (React.createElement("div", { className: `${tagTimerEnd} tag-text-wrapper ${isTagTextVisible ? 'tag-text-visible' : ''}` }, (isTimer || !timeLeft.completed || isText || isHTML) && (React.createElement("div", { className: `tag-type-text ${((timerEndText === '' && timeLeft.completed && tagText === '') ? 'empty' : '')}` },
        ((!timeLeft.completed || isText)) && (React.createElement(TagTextWrapper, { className: "tag-text" }, tagText)),
        isHTML && React.createElement("span", { dangerouslySetInnerHTML: { __html: tagText } }),
        (isTimer) && (React.createElement("span", { className: `${(timeLeft.completed ? 'color-tag' : 'tag-timer-text')}` }, TimerText(timeLeft, timerEndText)))))));
};
export default Timer;
